import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fillIfEmptyValue'
})
export class FillIfEmptyValuePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return value || '-';
  }

}
